<template>
  <SelectComponent
    v-model="localModelValue"
    :values="options"
    :multiple="multiple"
    :searchable="searchable"
    :label="cLabel"
    :track-by="trackBy"
    :display-key="attributeLabel"
    :disabled="disabled"
    :required="required"
    :errors="cErrors"
    :name="name"
    :placeholder="placeholder ?? cLabel"
    :edition-mode="editionMode"
    :label-class="labelClass"
    :select-class="selectClass"
  />
</template>

<script>
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

import { fieldErrors } from './fieldErrors'

/**
 * Show/edit select fed by one list of the page's `metadata` object
 * (`metadata.companies`, `metadata.languages`…). Base of the Crema-only
 * `Base<Entity>ShowEditSelect{Simple,Multiple}` components that the former
 * `@addf/addf-vue-base-components` package provided: same props, same
 * `v-model` (an id, or an array of ids when `multiple`).
 */
export default {
  name: 'MetadataShowEditSelect',
  components: { SelectComponent },
  props: {
    editionMode: { type: Boolean, default: true },
    modelValue: {
      type: [Number, String, Array, Object, Boolean],
      required: false,
      default: null
    },
    metadata: { type: [Object, Array], required: false, default: null },
    metadataKey: { type: String, required: true },
    labelKey: { type: String, required: false, default: null },
    multiple: { type: Boolean, required: false, default: false },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    label: { type: String, required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    name: { type: String, required: false, default: null },
    errors: { type: [Object, Array], required: false, default: () => [] },
    required: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    searchable: { type: Boolean, required: false, default: false },
    labelClass: { type: String, required: false, default: '' },
    selectClass: { type: String, required: false, default: '' }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    cErrors() {
      return fieldErrors(this.errors, this.name)
    },
    options() {
      return this.metadata?.[this.metadataKey] ?? []
    },
    cLabel() {
      if (this.label) return this.label
      return this.labelKey ? this.$t(`attributes.${this.labelKey}`) : null
    },
    localModelValue: {
      get() {
        if (this.multiple) return this.modelValue ?? []
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>
